(function() {
  var clearEvents = ['change', 'keyup', 'paste', 'input'];

  function clearInvalid(e) {
    var _el = this;
    _el.classList.remove('c-form-control--invalid');
    clearEvents.forEach(function(eventname) {
      _el.removeEventListener(eventname, clearInvalid);
    });
  }
  
  Drupal.behaviors.formValidator = {
    attach(context, settings) {
      var _forms = context.querySelectorAll('form');
      for(var i = 0; i < _forms.length; i++) {
        _forms[i].addEventListener('invalid', (e) => {
          var _input = e.target;
          _input.classList.add('c-form-control--invalid');
          clearEvents.forEach(function(eventname) {
            _el.addEventListener(eventname, clearInvalid);
          });
        },true);
      }
    }
  }  
})();
